import liveChatService, {
  CustomVariable,
} from 'commons/liveChat/liveChatService';
import { defineStore } from 'pinia';

type State = {
  enabled: boolean;
  open: boolean;
  unreadMessages: number;
};

export const useLiveChatStore = defineStore('liveChat', {
  state: (): State => ({
    enabled: false,
    open: false,
    unreadMessages: 0,
  }),

  actions: {
    setEnabled(enabled: State['enabled']) {
      this.enabled = enabled;
    },
    setUnreadMessages(unreadMessages: State['unreadMessages']) {
      this.unreadMessages = unreadMessages;
    },
    setOpen(open: State['open']) {
      this.open = open;
    },
    async init(customVariables: CustomVariable[]) {
      if (!liveChatService.isEnabled()) {
        this.setEnabled(false);
        return;
      }

      try {
        await liveChatService.init(customVariables, (count) =>
          this.setUnreadMessages(count),
        );
        liveChatService.onOpenChange((open) => this.setOpen(open));
        this.setEnabled(true);
      } catch (e) {
        this.setEnabled(false);
        console.error('Failed to initialize live chat', e);
      }
    },
    openChat() {
      liveChatService.openChat();
    },
    clearSession() {
      liveChatService.clearSession();
    },
  },
});
